// ═══════════════════════════════════════════════════════════════════════════════
// Layout tokens for MainAppShell + BottomNav (flex footer: h-16 row + 16px + safe-area).
// ═══════════════════════════════════════════════════════════════════════════════

/** PWA: full-viewport shell; bottom nav is a flex child (not position:fixed). */
export const MAIN_APP_SHELL_PWA_CLASS =
  'flex h-full min-h-0 flex-1 flex-col overflow-hidden bg-[#f7f8fb] dark:bg-gray-950';

/** Browser tab: document scroll; Chrome can auto-hide its UI bars. */
export const MAIN_APP_SHELL_BROWSER_CLASS =
  'flex min-h-screen flex-col bg-[#f7f8fb] dark:bg-gray-950';

/** PWA inner scroll region between top bar and bottom nav. */
export const MAIN_APP_SCROLL_PWA_CLASS =
  'mx-auto w-full max-w-lg min-h-0 flex-1 overflow-y-auto overscroll-y-none [-webkit-overflow-scrolling:touch]';

/** Browser: normal document flow; padding clears fixed top/bottom chrome (+ optional Play banner). */
export const MAIN_APP_SCROLL_BROWSER_CLASS =
  'mx-auto w-full max-w-lg flex-1 pt-[calc(56px+env(safe-area-inset-top,0px)+var(--fdh-play-banner-h,0px))] pb-[calc(4rem+max(16px,env(safe-area-inset-bottom,0px)))]';

/** @deprecated Use MAIN_APP_SHELL_PWA_CLASS */
export const MAIN_APP_SHELL_CLASS = MAIN_APP_SHELL_PWA_CLASS;

/** @deprecated Use MAIN_APP_SCROLL_PWA_CLASS */
export const MAIN_APP_SCROLL_CLASS = MAIN_APP_SCROLL_PWA_CLASS;

/** Clears fixed AppTopBar (56px row + safe-area-top). PWA inner scroll only. */
export const MAIN_APP_SCROLL_TOP_PADDING_CLASS =
  'pt-[calc(56px+env(safe-area-inset-top,0px))]';

/** Clears fixed AppTopBar for in-shell strips (e.g. web push prompt) with 0.75rem gap. */
export const MAIN_APP_BELOW_TOP_BAR_CLASS =
  'pt-[calc(56px+env(safe-area-inset-top,0px)+var(--fdh-play-banner-h,0px)+0.75rem)]';

/** PWA flex footer bottom nav. */
export const BOTTOM_NAV_PWA_CLASS =
  'relative z-30 shrink-0 w-full border-t border-gray-200 bg-white pb-[max(16px,env(safe-area-inset-bottom,0px))] dark:border-gray-700 dark:bg-gray-900';

/** Browser fixed bottom nav. */
export const BOTTOM_NAV_BROWSER_CLASS =
  'fixed bottom-0 left-0 right-0 z-30 border-t border-gray-200 bg-white pb-[max(16px,env(safe-area-inset-bottom,0px))] [transform:translateZ(0)] dark:border-gray-700 dark:bg-gray-900';

/** Fixed strip above BottomNav (64px row + max(16px, safe-area) — matches BottomNav.tsx). */
export const FIXED_ABOVE_BOTTOM_NAV =
  'fixed left-0 right-0 z-40 bottom-[calc(4rem+max(16px,env(safe-area-inset-bottom,0px)))]';

/** Approximate bottom nav block height for PWA focus-scroll clearance (64px row + safe-area). */
export const BOTTOM_NAV_SCROLL_CLEARANCE_PX = 80;

/** Extra scroll padding so form/content clears one full-width fixed action row. */
export const SCROLL_BOTTOM_FOR_FIXED_ACTION_ROW = 'pb-32';

/** Extra scroll padding when review row + FAB may stack above BottomNav. */
export const SCROLL_BOTTOM_FOR_REVIEW_AND_FAB = 'pb-56';

/** FAB above full-width review action row (nav + prompt label + icon row + gap). */
export const PAGE_PRIMARY_FAB_ABOVE_REVIEW_ROW_BOTTOM =
  'bottom-[calc(4rem+max(16px,env(safe-area-inset-bottom,0px))+7rem+12px)]';

/** Extra scroll padding when employer floating review bar is visible. */
export const SCROLL_BOTTOM_FOR_REVIEW_BAR = 'pb-44';

/** Extra top padding when the Android Play install banner is visible. */
export const PLAY_BANNER_OFFSET_PADDING_CLASS = 'pt-[var(--fdh-play-banner-h,0px)]';

/** For `absolute top-4` chrome that must sit below the Play banner. */
export const PLAY_BANNER_ABSOLUTE_TOP_4_CLASS = 'top-[calc(1rem+var(--fdh-play-banner-h,0px))]';

/** Floating card (e.g. PWA prompt) above BottomNav with 1rem gap. */
export const FLOATING_CARD_ABOVE_BOTTOM_NAV =
  'bottom-[calc(1rem+4rem+max(16px,env(safe-area-inset-bottom,0px)))]';
